import { useMutation } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export const useSubscribers = () => {
  return useMutation({
    mutationFn: async ({ email, full_name }) => {
      const { data, error } = await supabase
        .from('subscribers')
        .insert([{ email, full_name }]);

      if (error) throw error;
      return data;
    },
  });
};
